import React, { useContext, useEffect, useState } from "react";
import styles from "./Login.module.css";
import { useNavigate, Navigate, Link } from "react-router-dom";
import LineChart from "../../assets/line-chart.gif";
import BotIcon from "../../assets/botIco.svg";
import jwt_decode from "jwt-decode";
// import Typewriter from "typewriter-effect";
import { Modal } from "@fluentui/react";
import { AppStateContext } from "../../state/AppProvider";
import { fetchModelDetails } from "../../api";

async function loginUser(credentials: any) {
  const userinfo = credentials.username;
  //@ts-ignore
  const domain = userinfo.split("\\")[0];
  //@ts-ignore
  const uname = userinfo.split("\\")[1];

  const items = {
    username: uname,
    password: credentials.password,
    domain: domain,
  };

  return fetch("https://genie-uat.motherson.com", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(items),
  }).then((data) => data.json());
}

function base64Decode(str: string) {
  try {
    return JSON.parse(
      decodeURIComponent(
        atob(str)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      ),
    );
  } catch (e) {
    console.error("Base64 decode error:", e);
    return null;
  }
}

function parseJwt(token: string) {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) {
      return null;
    }
    return base64Decode(base64Url);
  } catch (e) {
    console.error("JWT parse error:", e);
    return null;
  }
}

export default function Login() {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [Email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const appStateContext = useContext(AppStateContext);

  useEffect(() => {
    const accessToken = localStorage.getItem("AccessToken");

    if (accessToken) {
      navigate("/");
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!Email) {
      setError("Email is required");
      setTimeout(() => setError(null), 5000);
      return;
    } else if (!emailRegex.test(Email)) {
      setError("Invalid email format");
      setTimeout(() => setError(null), 5000);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch("/api/Check_User_in_DB", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Email }),
      });

      const data = await response.json();

      if (response.ok && data.status === "Success" && data.auth_url) {
        localStorage.setItem("Email", Email);
        const sortedModels = await fetchModelDetails(Email, data?.Is_Prysm === true || data?.Is_Prysm === 1 || data?.Is_Prysm === "true");

        const modelOnly = sortedModels.filter(
          (m: any) => m.Category === "Model",
        );
        const appOnly = sortedModels.filter((m: any) => m.Category === "App");

        appStateContext?.dispatch({
          type: "SET_MODEL_CATEGORY",
          payload: modelOnly,
        });

        appStateContext?.dispatch({
          type: "SET_APP_CATEGORY",
          payload: appOnly,
        });
        // await appStateContext?.initChatHistory?.();

        window.location.replace(data.auth_url);
        return;
      }

      if (response.ok && data.message !== "User does not exist") {
        localStorage.setItem("Email", Email);

        const sortedModels = await fetchModelDetails(Email, data?.Is_Prysm === true || data?.Is_Prysm === 1 || data?.Is_Prysm === "true");

        const modelOnly = sortedModels.filter(
          (m: any) => m.Category === "Model",
        );
        const appOnly = sortedModels.filter((m: any) => m.Category === "App");

        appStateContext?.dispatch({
          type: "SET_MODEL_CATEGORY",
          payload: modelOnly,
        });

        appStateContext?.dispatch({
          type: "SET_APP_CATEGORY",
          payload: appOnly,
        });

        window.location.replace("/auth");
        return;
      }

      setShowFeedbackModal(true);
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   const parts = usernameInput.split("\\");
  //   if (parts.length !== 2) {
  //     setError("Please enter username in Domain\\Username format");
  //     setTimeout(() => setError(null), 5000);
  //     return;
  //   }

  //   const [domain, username] = parts;

  //   try {
  //     const response = await fetch(
  //       "/Check_User_Eligibility",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           WindowID: username,
  //           Domain: domain,
  //         }),
  //       }
  //     );

  //     const data = await response.json();

  //     if (response.ok && data.message !== "User does not exist") {
  //       localStorage.setItem("userId", username);
  //       localStorage.setItem("domain", domain);

  //       localStorage.setItem("sessionStart", Date.now().toString());

  //       navigate("/");
  //     } else {
  //       setError("You are not an authorized user.");
  //       setTimeout(() => setError(null), 5000);
  //     }
  //   } catch (err) {
  //     console.error("Login error:", err);
  //     setError("Something went wrong. Please try again.");
  //     setTimeout(() => setError(null), 5000);
  //   }
  //   setLoading(false);
  // };

  const onClose = () => {
    setShowFeedbackModal(false);
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.leftSide}>
        {/* <div className={styles.logoWrp}>
         
          <i>
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 109 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M103.473 8.02431C102.315 8.02431 101.32 7.64944 100.487 6.8997C99.6747 6.14994 99.2686 5.19758 99.2686 4.04256C99.2686 2.88754 99.6747 1.92503 100.487 1.15502C101.32 0.385005 102.315 0 103.473 0C104.671 0 105.686 0.385005 106.519 1.15502C107.352 1.92503 107.768 2.88754 107.768 4.04256C107.768 5.13677 107.352 6.07903 106.519 6.86931C105.686 7.63931 104.671 8.02431 103.473 8.02431ZM106.976 42.1581C106.976 44.1053 105.394 45.6838 103.442 45.6838C101.49 45.6838 99.9083 44.1053 99.9083 42.1581V18.0851C99.9083 16.1378 101.49 14.5593 103.442 14.5593C105.394 14.5593 106.976 16.1378 106.976 18.0851V42.1581Z"
                fill="white"
              />
              <path
                d="M70.0538 40.0772C70.0388 40.053 70.0121 40.0378 69.9835 40.0378C69.9382 40.0378 69.9014 40.0746 69.9014 40.1199V56.2914C69.9014 58.3397 68.2371 60 66.1843 60C64.1314 60 62.467 58.3395 62.467 56.2914V15.7289C62.467 13.6806 64.1314 12.0202 66.1843 12.0202H67.0063C68.6052 12.0202 69.9014 13.3134 69.9014 14.9087V17.7159C69.9014 17.7607 69.9379 17.7971 69.9828 17.7971C70.0117 17.7971 70.0386 17.7814 70.0533 17.7564C72.5948 13.4188 76.304 11.25 81.181 11.25C85.3467 11.25 88.594 12.7156 90.9224 15.6468C93.2511 18.578 94.4153 22.5148 94.4153 27.4571C94.4153 32.9346 93.1015 37.3206 90.4738 40.6155C87.8462 43.9104 84.2573 45.558 79.7069 45.558C75.5348 45.558 72.3171 43.731 70.0538 40.0772ZM69.8373 27.072V31.1479C69.8373 33.5443 70.5956 35.5768 72.1124 37.2458C73.6506 38.9145 75.5946 39.7491 77.9445 39.7491C80.7003 39.7491 82.8579 38.6792 84.4176 36.5396C85.9983 34.3787 86.7887 31.3727 86.7887 27.5214C86.7887 24.2906 86.0518 21.7659 84.5777 19.9474C83.125 18.1073 81.1489 17.1873 78.6496 17.1873C76.0005 17.1873 73.8641 18.1287 72.2406 20.0115C70.6385 21.8944 69.8373 24.2479 69.8373 27.072Z"
                fill="white"
              />
              <path
                d="M48.7936 43.1359C48.7911 43.0226 48.7434 42.9148 48.6599 42.8348C48.5765 42.7547 48.4639 42.7088 48.3459 42.7065L34.9975 42.7078C34.987 42.7078 34.9782 42.7022 34.9677 42.7022C34.9058 42.6986 34.8448 42.6881 34.7856 42.6707C34.7457 42.6634 34.7066 42.6533 34.6685 42.6399C34.613 42.6129 34.5612 42.5796 34.514 42.5404C34.4826 42.5205 34.4527 42.4986 34.4245 42.4746C34.3832 42.4283 34.3473 42.3776 34.3178 42.3236C34.2979 42.2942 34.2798 42.2636 34.2642 42.2319C34.259 42.2198 34.2447 42.2134 34.2432 42.1976L30.2474 30.8378C30.0444 30.1551 30.014 29.4356 30.1587 28.7394C30.3034 28.0431 30.6189 27.39 31.0792 26.8339L40.0409 16.0194C40.3062 15.6958 40.6462 15.4354 41.0339 15.2586C41.4216 15.0818 41.8467 14.9935 42.2761 15.0004L42.2804 15.0047L42.2849 15.0004L42.3007 15.004C42.6742 14.9995 43.0449 15.0668 43.3909 15.202C43.7369 15.3372 44.0511 15.5375 44.315 15.7911C44.392 15.8651 44.4646 15.9432 44.532 16.0252L53.4922 26.8369C53.9551 27.3983 54.271 28.0579 54.4136 28.7604C54.5563 29.463 54.5215 30.1881 54.3122 30.8751L52.4283 36.2316C52.3956 36.3266 52.3438 36.4146 52.2754 36.4903C52.2071 36.5661 52.1239 36.6281 52.0307 36.6728C51.9373 36.7176 51.8356 36.7442 51.7315 36.7511C51.6274 36.7581 51.5229 36.7451 51.4238 36.7131C51.325 36.681 51.2337 36.6306 51.1551 36.5646C51.0767 36.4986 51.0127 36.4183 50.9666 36.3285C50.9206 36.2387 50.8935 36.141 50.8871 36.0411C50.8805 35.9411 50.8948 35.841 50.9288 35.7463L52.8014 30.4236C52.9352 29.973 52.9553 29.4986 52.8598 29.0393C52.7645 28.5799 52.5565 28.149 52.253 27.7821L43.3018 16.9648C43.2372 16.8891 43.1633 16.8211 43.0818 16.7622V26.4604C44.0701 26.6486 44.9502 27.183 45.5506 27.9593C46.1511 28.7355 46.429 29.6983 46.3304 30.6602C46.2317 31.6221 45.7636 32.5146 45.0169 33.1637C44.2703 33.8128 43.2986 34.1724 42.291 34.1724C41.2833 34.1724 40.3117 33.8128 39.565 33.1637C38.8184 32.5146 38.3502 31.6221 38.2516 30.6602C38.1529 29.6983 38.4309 28.7355 39.0313 27.9593C39.6317 27.183 40.5118 26.6486 41.5002 26.4604L41.4994 16.7601C41.4182 16.82 41.3455 16.8898 41.2831 16.9676L32.3199 27.7764C32.019 28.1385 31.8116 28.5636 31.7148 29.0171C31.618 29.4707 31.6343 29.94 31.7627 30.3863L35.5675 41.1923L48.3489 41.1879C48.6154 41.1878 48.8793 41.2378 49.1255 41.3355C49.3716 41.4332 49.5955 41.5766 49.7838 41.7574C49.9723 41.9381 50.1217 42.1526 50.2235 42.3889C50.3254 42.6249 50.3776 42.8781 50.3774 43.1336L50.3782 46.7998C50.378 47.316 50.1641 47.811 49.7836 48.1761C49.403 48.5409 48.8872 48.7461 48.3489 48.7462L31.6699 48.7498C31.5648 48.7517 31.4605 48.7333 31.3628 48.696C31.2652 48.6587 31.1763 48.6032 31.1014 48.5325C31.0264 48.462 30.9668 48.3778 30.9262 48.2848C30.8854 48.1918 30.8644 48.0921 30.8644 47.9914C30.8644 47.8905 30.8852 47.7908 30.9258 47.6978C30.9664 47.6048 31.0258 47.5206 31.1008 47.4499C31.1758 47.3792 31.2645 47.3235 31.362 47.2862C31.4597 47.2487 31.564 47.2303 31.6691 47.232L48.3482 47.2313C48.407 47.2316 48.4654 47.2207 48.5199 47.1992C48.5743 47.1778 48.6239 47.1461 48.6654 47.1062C48.7071 47.0663 48.74 47.0188 48.7624 46.9667C48.7847 46.9144 48.7962 46.8585 48.7958 46.8019L48.7936 43.1359ZM40.546 31.9414C40.8911 32.2723 41.3308 32.4979 41.8095 32.5892C42.2881 32.6805 42.7845 32.6336 43.2353 32.4544C43.6864 32.2753 44.0718 31.9719 44.3428 31.5827C44.614 31.1933 44.7589 30.7358 44.7589 30.2676C44.7589 29.7994 44.614 29.3417 44.3428 28.9524C44.0718 28.563 43.6864 28.2596 43.2353 28.0806C42.7845 27.9013 42.2881 27.8544 41.8095 27.9458C41.3308 28.0371 40.8911 28.2626 40.546 28.5936C40.0837 29.0378 39.824 29.6398 39.824 30.2676C39.824 30.8951 40.0837 31.4972 40.546 31.9414Z"
                fill="white"
                stroke="white"
                stroke-width="0.9"
              />
              <path
                d="M43.6885 8.42644C46.0207 8.42644 47.9114 6.54012 47.9114 4.21322C47.9114 1.88632 46.0207 0 43.6885 0C41.3562 0 39.4656 1.88632 39.4656 4.21322C39.4656 6.54012 41.3562 8.42644 43.6885 8.42644Z"
                fill="white"
              />
              <path
                d="M26.3103 47.3462C26.3103 49.1571 24.839 50.625 23.024 50.625H3.75862C1.68279 50.625 0 48.9461 0 46.875V3.75C0 1.67893 1.68279 0 3.75862 0H4.12785C6.20368 0 7.88647 1.67893 7.88647 3.75V40.3174C7.88647 42.3883 9.56926 44.0674 11.6451 44.0674H23.024C24.839 44.0674 26.3103 45.5353 26.3103 47.3462Z"
                fill="white"
              />
            </svg>
          </i>
        </div>       */}
        <div className={styles.lipiOverview_wrapper}>
          <h1>
            Welcome to <span>Lipi!</span>
          </h1>
          {/* <h1>
          
            <Typewriter
  onInit={(typewriter) => {
    typewriter.typeString('Welcome on Lipi!')
      .callFunction(() => {
        console.log('String typed out!');
      })
      .pauseFor(100)
      .deleteAll()
      .callFunction(() => {
        console.log('All strings were deleted');
      })
      .start();
  }}
/> 
          </h1>*/}
          <p className={styles.lipiOverview_text}>
            <span>Lipi</span> is a versatile chatbot platform that combines
            multiple AI models to deliver personalized and efficient
            interactions. It adapts to various needs—from casual chats to
            complex problem-solving-offering accurate, context-aware responses.
            Ideal for customer service, finance, retail, automotive and
            manufacturing, <span>Lipi</span> continuously improves to power
            smarter conversations.
          </p>
        </div>
      </div>

      <div className={styles.loginForm}>
        <div className={styles.forWrp}>
          <div className={styles.forWrp__inner}>
            <div className={styles.forWrp__inner__logo}>
              <i>
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 109 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M103.473 8.02431C102.315 8.02431 101.32 7.64944 100.487 6.8997C99.6747 6.14994 99.2686 5.19758 99.2686 4.04256C99.2686 2.88754 99.6747 1.92503 100.487 1.15502C101.32 0.385005 102.315 0 103.473 0C104.671 0 105.686 0.385005 106.519 1.15502C107.352 1.92503 107.768 2.88754 107.768 4.04256C107.768 5.13677 107.352 6.07903 106.519 6.86931C105.686 7.63931 104.671 8.02431 103.473 8.02431ZM106.976 42.1581C106.976 44.1053 105.394 45.6838 103.442 45.6838C101.49 45.6838 99.9083 44.1053 99.9083 42.1581V18.0851C99.9083 16.1378 101.49 14.5593 103.442 14.5593C105.394 14.5593 106.976 16.1378 106.976 18.0851V42.1581Z"
                    fill="white"
                  ></path>
                  <path
                    d="M70.0538 40.0772C70.0388 40.053 70.0121 40.0378 69.9835 40.0378C69.9382 40.0378 69.9014 40.0746 69.9014 40.1199V56.2914C69.9014 58.3397 68.2371 60 66.1843 60C64.1314 60 62.467 58.3395 62.467 56.2914V15.7289C62.467 13.6806 64.1314 12.0202 66.1843 12.0202H67.0063C68.6052 12.0202 69.9014 13.3134 69.9014 14.9087V17.7159C69.9014 17.7607 69.9379 17.7971 69.9828 17.7971C70.0117 17.7971 70.0386 17.7814 70.0533 17.7564C72.5948 13.4188 76.304 11.25 81.181 11.25C85.3467 11.25 88.594 12.7156 90.9224 15.6468C93.2511 18.578 94.4153 22.5148 94.4153 27.4571C94.4153 32.9346 93.1015 37.3206 90.4738 40.6155C87.8462 43.9104 84.2573 45.558 79.7069 45.558C75.5348 45.558 72.3171 43.731 70.0538 40.0772ZM69.8373 27.072V31.1479C69.8373 33.5443 70.5956 35.5768 72.1124 37.2458C73.6506 38.9145 75.5946 39.7491 77.9445 39.7491C80.7003 39.7491 82.8579 38.6792 84.4176 36.5396C85.9983 34.3787 86.7887 31.3727 86.7887 27.5214C86.7887 24.2906 86.0518 21.7659 84.5777 19.9474C83.125 18.1073 81.1489 17.1873 78.6496 17.1873C76.0005 17.1873 73.8641 18.1287 72.2406 20.0115C70.6385 21.8944 69.8373 24.2479 69.8373 27.072Z"
                    fill="white"
                  ></path>
                  <path
                    d="M48.7936 43.1359C48.7911 43.0226 48.7434 42.9148 48.6599 42.8348C48.5765 42.7547 48.4639 42.7088 48.3459 42.7065L34.9975 42.7078C34.987 42.7078 34.9782 42.7022 34.9677 42.7022C34.9058 42.6986 34.8448 42.6881 34.7856 42.6707C34.7457 42.6634 34.7066 42.6533 34.6685 42.6399C34.613 42.6129 34.5612 42.5796 34.514 42.5404C34.4826 42.5205 34.4527 42.4986 34.4245 42.4746C34.3832 42.4283 34.3473 42.3776 34.3178 42.3236C34.2979 42.2942 34.2798 42.2636 34.2642 42.2319C34.259 42.2198 34.2447 42.2134 34.2432 42.1976L30.2474 30.8378C30.0444 30.1551 30.014 29.4356 30.1587 28.7394C30.3034 28.0431 30.6189 27.39 31.0792 26.8339L40.0409 16.0194C40.3062 15.6958 40.6462 15.4354 41.0339 15.2586C41.4216 15.0818 41.8467 14.9935 42.2761 15.0004L42.2804 15.0047L42.2849 15.0004L42.3007 15.004C42.6742 14.9995 43.0449 15.0668 43.3909 15.202C43.7369 15.3372 44.0511 15.5375 44.315 15.7911C44.392 15.8651 44.4646 15.9432 44.532 16.0252L53.4922 26.8369C53.9551 27.3983 54.271 28.0579 54.4136 28.7604C54.5563 29.463 54.5215 30.1881 54.3122 30.8751L52.4283 36.2316C52.3956 36.3266 52.3438 36.4146 52.2754 36.4903C52.2071 36.5661 52.1239 36.6281 52.0307 36.6728C51.9373 36.7176 51.8356 36.7442 51.7315 36.7511C51.6274 36.7581 51.5229 36.7451 51.4238 36.7131C51.325 36.681 51.2337 36.6306 51.1551 36.5646C51.0767 36.4986 51.0127 36.4183 50.9666 36.3285C50.9206 36.2387 50.8935 36.141 50.8871 36.0411C50.8805 35.9411 50.8948 35.841 50.9288 35.7463L52.8014 30.4236C52.9352 29.973 52.9553 29.4986 52.8598 29.0393C52.7645 28.5799 52.5565 28.149 52.253 27.7821L43.3018 16.9648C43.2372 16.8891 43.1633 16.8211 43.0818 16.7622V26.4604C44.0701 26.6486 44.9502 27.183 45.5506 27.9593C46.1511 28.7355 46.429 29.6983 46.3304 30.6602C46.2317 31.6221 45.7636 32.5146 45.0169 33.1637C44.2703 33.8128 43.2986 34.1724 42.291 34.1724C41.2833 34.1724 40.3117 33.8128 39.565 33.1637C38.8184 32.5146 38.3502 31.6221 38.2516 30.6602C38.1529 29.6983 38.4309 28.7355 39.0313 27.9593C39.6317 27.183 40.5118 26.6486 41.5002 26.4604L41.4994 16.7601C41.4182 16.82 41.3455 16.8898 41.2831 16.9676L32.3199 27.7764C32.019 28.1385 31.8116 28.5636 31.7148 29.0171C31.618 29.4707 31.6343 29.94 31.7627 30.3863L35.5675 41.1923L48.3489 41.1879C48.6154 41.1878 48.8793 41.2378 49.1255 41.3355C49.3716 41.4332 49.5955 41.5766 49.7838 41.7574C49.9723 41.9381 50.1217 42.1526 50.2235 42.3889C50.3254 42.6249 50.3776 42.8781 50.3774 43.1336L50.3782 46.7998C50.378 47.316 50.1641 47.811 49.7836 48.1761C49.403 48.5409 48.8872 48.7461 48.3489 48.7462L31.6699 48.7498C31.5648 48.7517 31.4605 48.7333 31.3628 48.696C31.2652 48.6587 31.1763 48.6032 31.1014 48.5325C31.0264 48.462 30.9668 48.3778 30.9262 48.2848C30.8854 48.1918 30.8644 48.0921 30.8644 47.9914C30.8644 47.8905 30.8852 47.7908 30.9258 47.6978C30.9664 47.6048 31.0258 47.5206 31.1008 47.4499C31.1758 47.3792 31.2645 47.3235 31.362 47.2862C31.4597 47.2487 31.564 47.2303 31.6691 47.232L48.3482 47.2313C48.407 47.2316 48.4654 47.2207 48.5199 47.1992C48.5743 47.1778 48.6239 47.1461 48.6654 47.1062C48.7071 47.0663 48.74 47.0188 48.7624 46.9667C48.7847 46.9144 48.7962 46.8585 48.7958 46.8019L48.7936 43.1359ZM40.546 31.9414C40.8911 32.2723 41.3308 32.4979 41.8095 32.5892C42.2881 32.6805 42.7845 32.6336 43.2353 32.4544C43.6864 32.2753 44.0718 31.9719 44.3428 31.5827C44.614 31.1933 44.7589 30.7358 44.7589 30.2676C44.7589 29.7994 44.614 29.3417 44.3428 28.9524C44.0718 28.563 43.6864 28.2596 43.2353 28.0806C42.7845 27.9013 42.2881 27.8544 41.8095 27.9458C41.3308 28.0371 40.8911 28.2626 40.546 28.5936C40.0837 29.0378 39.824 29.6398 39.824 30.2676C39.824 30.8951 40.0837 31.4972 40.546 31.9414Z"
                    fill="white"
                    stroke="white"
                    stroke-width="0.9"
                  ></path>
                  <path
                    d="M43.6885 8.42644C46.0207 8.42644 47.9114 6.54012 47.9114 4.21322C47.9114 1.88632 46.0207 0 43.6885 0C41.3562 0 39.4656 1.88632 39.4656 4.21322C39.4656 6.54012 41.3562 8.42644 43.6885 8.42644Z"
                    fill="white"
                  ></path>
                  <path
                    d="M26.3103 47.3462C26.3103 49.1571 24.839 50.625 23.024 50.625H3.75862C1.68279 50.625 0 48.9461 0 46.875V3.75C0 1.67893 1.68279 0 3.75862 0H4.12785C6.20368 0 7.88647 1.67893 7.88647 3.75V40.3174C7.88647 42.3883 9.56926 44.0674 11.6451 44.0674H23.024C24.839 44.0674 26.3103 45.5353 26.3103 47.3462Z"
                    fill="white"
                  ></path>
                </svg>
              </i>
            </div>

            <div className={styles.loginElementWrapper}>
              {/* <h2>Welcome!</h2> */}

              <p>Sign in to proceed to your account.</p>

              <form
                onSubmit={handleSubmit}
                className={styles.forWrp__signInform}
              >
                <div className={styles.email__wrapper}>
                  <div className={styles.formGroup}>
                    {/* <label>Username</label> */}
                    {/* <i className={styles.userIcon}>
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    height="100%"
                    width="100%"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M18 20a6 6 0 0 0-12 0"></path>
                    <circle cx="12" cy="10" r="4"></circle>
                    <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                </i> */}
                    <input
                      className={styles.formControl}
                      type="text"
                      onChange={(e: any) => setEmail(e.target.value)}
                      placeholder="Enter Your Email Id"
                    />

                    {/* <span className={styles.userErrorMesg}>You are not authorized user.</span> */}
                  </div>
                  <button className={styles.nextButton} title="Next">
                    <i>
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        height="100%"
                        width="100%"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="none"
                          stroke-width="2"
                          d="M2,12 L22,12 M13,3 L22,12 L13,21"
                        ></path>
                      </svg>
                    </i>
                  </button>
                </div>

                {/* <p className="mt-3">
                  Don’t have an account?{" "}
                  <Link to="/signup" className={styles.signInUpText}>
                    Sign up
                  </Link>
                </p> */}
                {error && <div className={styles.errorMessage}>{error}</div>}
              </form>
            </div>

            <div className={styles.poweredByWrapper}>
              <span className={styles.poweredByonLogin}>
                Powered by
                <svg
                  height="28"
                  viewBox="0 0 89 20"
                  width="92"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Samvardhana Motherson</title>
                  <path
                    d="M85.535 1.38a2.464 2.464 0 0 0-1.478 2.231v16.107h3.45c.817 0 1.479-.662 1.479-1.479V0zm-6.408 4.93a2.466 2.466 0 0 0-1.479 2.23v11.178h3.45a1.48 1.48 0 0 0 1.48-1.479V4.93zm-6.409 4.93a2.465 2.465 0 0 0-1.478 2.23v6.248h3.45c.817 0 1.479-.662 1.479-1.479V9.86zM.784 12.97h2.27v1.014c.356-.634 1.054-1.192 2.082-1.192.875 0 1.484.38 1.801 1.103.571-.774 1.358-1.103 2.195-1.103 1.256 0 2.17.811 2.17 2.475v4.338H9.031v-3.959c0-.671-.33-1.001-.85-1.001-.61 0-1.015.393-1.015 1.116v3.844H4.92v-3.959c0-.671-.33-1.001-.85-1.001-.609 0-1.015.393-1.015 1.116v3.844H.784zm16.241 3.362v-.101c0-1.117-.443-1.739-1.306-1.739-.85 0-1.32.597-1.32 1.713v.101c0 1.143.444 1.765 1.32 1.765.85 0 1.306-.636 1.306-1.74m-4.948.039v-.101c0-2.132 1.587-3.477 3.642-3.477 2.043 0 3.616 1.306 3.616 3.413v.101c0 2.158-1.586 3.452-3.629 3.452-2.042 0-3.629-1.243-3.629-3.388m8.26 1.104v-2.956h-.799V12.97h.8v-.467l2.271-.916v1.383h1.307v1.548h-1.307v2.74c0 .483.24.699.672.699.254 0 .444-.038.647-.114v1.724a4.73 4.73 0 0 1-1.256.19c-1.497 0-2.335-.723-2.335-2.283m4.51-6.757l2.27-.926v4.244c.356-.685 1.08-1.243 2.184-1.243 1.28 0 2.17.799 2.17 2.5v4.313h-2.272v-3.857c0-.748-.292-1.116-.952-1.116-.672 0-1.13.406-1.13 1.256v3.717h-2.27zm12.143 4.816c-.039-.8-.432-1.244-1.168-1.244-.685 0-1.154.444-1.269 1.244zm-4.759.837v-.101c0-2.132 1.586-3.477 3.59-3.477 1.815 0 3.377 1.04 3.377 3.426v.596h-4.67c.064.875.571 1.384 1.383 1.384.749 0 1.066-.343 1.155-.788h2.132c-.204 1.498-1.359 2.348-3.363 2.348-2.081 0-3.604-1.218-3.604-3.388zm7.833-3.4h2.271v1.319c.419-.99 1.116-1.422 2.144-1.407V15c-1.383-.038-2.144.393-2.144 1.458v3.147h-2.271zm4.772 4.53h2.093c.077.482.292.748.94.748.558 0 .811-.216.811-.545 0-.318-.317-.47-1.23-.597-1.776-.228-2.526-.749-2.526-2.131 0-1.473 1.308-2.183 2.843-2.183 1.637 0 2.778.558 2.931 2.145h-2.056c-.089-.445-.33-.66-.85-.66-.495 0-.749.215-.749.52 0 .317.305.444 1.117.545 1.84.229 2.728.71 2.728 2.132 0 1.573-1.167 2.284-3.007 2.284-1.89 0-2.995-.788-3.045-2.259m11.413-1.167v-.101c0-1.117-.444-1.739-1.307-1.739-.85 0-1.319.597-1.319 1.713v.101c0 1.143.444 1.765 1.32 1.765.85 0 1.306-.636 1.306-1.74m-4.949.039v-.101c0-2.132 1.586-3.477 3.642-3.477 2.043 0 3.616 1.306 3.616 3.413v.101c0 2.158-1.586 3.452-3.629 3.452S51.3 18.515 51.3 16.37m8.066-3.4h2.272v1.065c.355-.685 1.078-1.243 2.182-1.243 1.282 0 2.17.799 2.17 2.5v4.313h-2.27v-3.857c0-.748-.292-1.116-.952-1.116-.672 0-1.13.406-1.13 1.256v3.717h-2.27z"
                    fill="currentColor"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
      {showFeedbackModal && (
        <Modal
          isOpen={true}
          onDismiss={onClose}
          isBlocking={false}
          containerClassName="modal-content-authorization"
          className={styles.authorization_modal_wrapper}
          // aria-labelledby="feedback-modal-title"
          // aria-describedby="feedback-modal-description"
        >
          <div className="d-flex align-items-center justify-content-between">
            <button onClick={onClose} className="close-btn-auth">
              <i>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 512 512"
                  height="100%"
                  width="100%"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"></path>
                </svg>
              </i>
            </button>
          </div>
          <div className={styles.authorization_wrapper}>
            <div className={styles.authrized_icon}>
              <i>
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="100%"
                  width="100%"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                  <path d="M12 9v4"></path>
                  <path d="M12 17h.01"></path>
                </svg>
              </i>
            </div>
            <h4>
              You are not authorized to access this application. Kindly do
              <Link to="/signup">Sign Up</Link>
            </h4>
          </div>
        </Modal>
      )}
    </div>
  );
}

